import { MessageDto } from '@platri/df-common-chat-plug-play';

export interface ChatDataInterface {
  date: Date;
  chatMessages: MessageDto[];
}
